import React, { useState, useRef } from "react";
import DatePicker, { CalendarContainer } from "react-datepicker";
import { withTranslation } from "react-i18next";
import "react-datepicker/dist/react-datepicker.css";
import "./CalendarDialog.scss";
import "../../../../shared/datePickerDialog/datePickerDialog.scss";
import CheckBox from "../../../../shared/checkBox/CheckBox";
import checkboxStyles from "../../../../shared/checkBox/CheckBox.module.scss";
import withStyles from '@mui/styles/withStyles';
import Clear from "@mui/icons-material/Clear";
import Button from "@mui/material/Button";
import UiDateUtils from "../../../../utils/UiDateUtils";
import Info from "@mui/icons-material/Info";
import { Tooltip } from "@mui/material";
import PricingTooltip from "./PricingTooltip";

const StyledClear = withStyles({
  root: {
    width: 35,
    height: 35,
    fill: "#102b4e",
    align: "right",
  },
})(Clear);

const StyledInfo = withStyles({
  root: {
    fill: "#4a90e2",
    width: 18,
    paddingTop: 5,
    paddingBottom: 5,
    marginLeft: -3,
    cursor: "pointer",
  },
})(Info);

const StyledTooltip = withStyles({
  popper: {
    opacity: 1,
    pointerEvents: "auto",
  },
  tooltip: {
    background: "white",
    boxShadow: "1px 1px 9px 0 rgba(0, 0, 0, 0.27)",
    paddingTop: 28,
    paddingLeft: 28,
    paddingRight: 28,
    paddingBottom: 18,
    maxWidth: 350,
  },
})(Tooltip);

function CalendarDialog(props) {
  const formatTodayDate = () => {
    const dateString = props.todayDate;
    const year = dateString.substring(0, 4);
    const month = dateString.substring(5, 7);
    const day = dateString.substring(8, 10);
    return new Date(year, month - 1, day);
  };

  const [dealerSelectedDate, setDealerSelectedDate] = useState(formatTodayDate());
  const [openTooltip, setOpenTooltip] = useState(false);
  const ref = useRef();

  function updateDate(date) {
    if (date !== null) {
      setDealerSelectedDate(date);
    }
  }

  function saveDateAndClose() {
    ref.current.setOpen(false);
    const year = dealerSelectedDate.getFullYear();
    const month = dealerSelectedDate.getMonth() + 1;
    const day = dealerSelectedDate.getDate();
    const formattedDate = UiDateUtils.formatDateYYYYMMDD(year, month, day);
    props.saveCalendarDate(
      UiDateUtils.saveDateFormat(formattedDate),
      props.type
    );
  }

  function toggleDatePickerDialog() {
    ref.current.setOpen(true);
  }

  function resetAndCloseDialog() {
    ref.current.setOpen(false);
  }

  function toggleTooltip() {
    setOpenTooltip(prevState => !prevState);
  }

  function closeTooltip() {
    setOpenTooltip(false);
  }

  function CalendarDialogContainer({ children }) {
    return (
      <div className="dialogContainer">
        <CalendarContainer id={props.id + "ContainerId"}>
          <div className="cancel">
            <button
              data-testid="closeDialogId"
              onClick={resetAndCloseDialog}
            >
              <StyledClear />
            </button>
          </div>
          <div className="dialogTitle">{props.dialogTitle}</div>
          <div className="dialogDescription">
            {props.dialogDescription}
          </div>
          <div className="calendarContainer">{children}</div>
        </CalendarContainer>
      </div>
    );
  }

  function CheckBoxSelector() {
    return (
      <CheckBox
        id={props.id + "CheckBoxId"}
        checked={props.isChecked}
        isDisabled={props.isDisabled}
        label={props.checkBoxText}
        onChange={() => toggleDatePickerDialog()}
        textClass={
          props.isDisabled
            ? props.isChecked
              ? checkboxStyles.boldLabel
              : checkboxStyles.disabledLabel
            : checkboxStyles.boldLabel
        }
      />
    );
  }

  function formatMaxDate() {
    const todayDate = props.todayDate.split("-");
    return new Date(todayDate[0], todayDate[1] - 1, todayDate[2]);
  }

  return (
    <div className="calendarDialogContainer dialogWrapper">
      <DatePicker
        ref={ref}
        id={props.id + "CalendarPickerId"}
        selected={dealerSelectedDate}
        withPortal
        shouldCloseOnSelect={false}
        maxDate={props.hasMaxDate && formatMaxDate()}
        onChange={updateDate}
        calendarContainer={CalendarDialogContainer}
        customInput={<CheckBoxSelector />}
      >
        <div className="applyButtonFormat">
          <Button
            className="applySave"
            name="applySave_name"
            data-testid="applySaveId"
            onClick={saveDateAndClose}
          >
            {props.t("CustomerOptOffline.applyAndSave")}
          </Button>
        </div>
      </DatePicker>
      {props.showTooltip && (
        <StyledTooltip
          data-testid="pricingTooltip"
          open={openTooltip}
          placement="bottom-start"
          title={<PricingTooltip closeTooltip={closeTooltip} />}
        >
          <StyledInfo onClick={toggleTooltip} fontSize="small" />
        </StyledTooltip>
      )}
    </div>
  );
}

export default withTranslation("emp")(CalendarDialog);
